module.exports = __webpack_public_path__ + "img/membership.330ae8a6.svg";